<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2020.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2020-12-27                                                         -
  ----------------------------------------------------------------------------->

<template>

</template>

<script>
export default {
  name: "yega1-axios-show-data-source",
  props:{
    storeName:{
      type:String,
      required:true
    },
    storeParameter:{
      type:String
    },
    initialLoad:{
      type: Boolean,
      default: true
    }
  },
  created(){
    if(this.initialLoad){
      this.loadItem();
    }
  },
  methods:{
    loadItem(){
      this.$store.dispatch(`${this.storeName}/show`,this.storeParameter)
          .then((item)=>{
            this.$emit('item-loaded',item)
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    reloadItem(newStoreParameter){
      this.$store.dispatch(`${this.storeName}/show`,newStoreParameter)
          .then((item)=>{
            this.$emit('item-loaded',item)
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    }
  }
}
</script>

<style scoped>

</style>
